export const focusRichTextEditor = (e: CKEditorEventInfo) => {
  if (e.editor) {
    e.editor.focus();
    // Set cursor to end of text
    const range = e.editor.createRange();
    range.moveToElementEditEnd(range.root);
    e.editor.getSelection().selectRanges([range]);
  }
};
